import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateFormPostprocessorFailure,
  CreateFormPostprocessorRequest,
  CreateFormPostprocessorSuccess,
  DeleteFormPostprocessorFailure,
  DeleteFormPostprocessorRequest,
  DeleteFormPostprocessorSuccess,
  FetchFormPostprocessorFailure,
  FetchFormPostprocessorRequest,
  FetchFormPostprocessorSuccess,
  FetchFormPostprocessorsFailure,
  FetchFormPostprocessorsRequest,
  FetchFormPostprocessorsSuccess,
  UpdateFormPostprocessorFailure,
  UpdateFormPostprocessorRequest,
  UpdateFormPostprocessorSuccess,
} from './form-postprocessors.actions'
import { FormPostprocessorsService } from './form-postprocessors.service'
import * as FormPostprocessorTypes from './form-postprocessors.types'

@Injectable()
export class FormPostprocessorsEffects {
  constructor(
    private actions: Actions,
    private formPostprocessorsService: FormPostprocessorsService,
    private router: Router,
  ) {}

  FetchFormPostprocessors$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormPostprocessorTypes.FETCH_FORM_POSTPROCESSORS_REQUEST),
      switchMap((action: FetchFormPostprocessorsRequest) => {
        return this.formPostprocessorsService
          .fetchFormPostprocessors(action.payload)
          .pipe(
            map((result) => {
              return new FetchFormPostprocessorsSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchFormPostprocessorsFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchFormPostprocessor$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormPostprocessorTypes.FETCH_FORM_POSTPROCESSOR_REQUEST),
      switchMap((action: FetchFormPostprocessorRequest) => {
        return this.formPostprocessorsService
          .fetchFormPostprocessor(action.id)
          .pipe(
            map((result) => {
              return new FetchFormPostprocessorSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(new FetchFormPostprocessorFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  DeleteFormPostprocessor$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormPostprocessorTypes.DELETE_FORM_POSTPROCESSOR_REQUEST),
      switchMap((action: DeleteFormPostprocessorRequest) => {
        return this.formPostprocessorsService
          .deleteFormPostprocessor(action.id)
          .pipe(
            switchMap((result) => {
              return [new DeleteFormPostprocessorSuccess()]
            }),
            catchError((err, caught) => {
              return of(new DeleteFormPostprocessorFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  CreateFormPostprocessor$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormPostprocessorTypes.CREATE_FORM_POSTPROCESSOR_REQUEST),
      switchMap((action: CreateFormPostprocessorRequest) => {
        return this.formPostprocessorsService
          .createFormPostprocessor(action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/form-postprocessors'])
              return [new CreateFormPostprocessorSuccess()]
            }),
            catchError((err, caught) => {
              return of(new CreateFormPostprocessorFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UpdateFormPostprocessor$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormPostprocessorTypes.UPDATE_FORM_POSTPROCESSOR_REQUEST),
      switchMap((action: UpdateFormPostprocessorRequest) => {
        return this.formPostprocessorsService
          .updateFormPostprocessor(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/form-postprocessors'])
              return [new UpdateFormPostprocessorSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateFormPostprocessorFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
